import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import {
	DatatableComponent,
	ColumnMode,
	SelectionType,
} from "@swimlane/ngx-datatable";
import { ClienteService } from "@core/services/cliente.service";
import Swal from "sweetalert2";

import { Subject } from "rxjs";
import { AuthenticationService } from "app/auth/service";
import { Router } from "@angular/router";
import { ClienteContatoService } from "@core/services/cliente-contato.service";
import { LeadService } from "@core/services/lead.service";

@Component({
	selector: 'app-listar-lead',
	templateUrl: './listar-lead.component.html',
	styleUrls: ['./listar-lead.component.scss']
})
export class ListarLeadComponent implements OnInit {
	// Private
	private _unsubscribeAll: Subject<any>;
	private tempData = [];

	// public
	public contentHeader: object;
	public selected = [];
	public basicSelectedOption: number = 10;
	public ColumnMode = ColumnMode;
	public contatoDel = [];
	public starting: boolean = false;

	rows = [];
	title = "angular-datatables";
	temp = [];
	customPatterns = { "0": { pattern: new RegExp("\\d") } };

	constructor(
		private clienteService: ClienteService,
		private leadService: LeadService,
		private clienteContatoService: ClienteContatoService
	) {
		this._unsubscribeAll = new Subject();
	}

	@ViewChild(DatatableComponent) table: DatatableComponent;
	@ViewChild("tableRowDetails") tableRowDetails: any;
	ngOnInit(): void {
		this.starting = true;

		this.leadService.findAll().subscribe(
			(res) => {
				
				(this.rows = res), (this.temp = res);
				this.starting = false;
			},
			(error) => {
				console.log(error);
				this.starting = false;
			}
		);

		this.contentHeader = {
			headerTitle: "Leads",
			actionButton: false,
			breadcrumb: {
				type: "",
				links: [
					{
						name: "Início",
						isLink: false,
					},
					{
						name: "Lead",
						isLink: false,
					},
				],
			},
		};
	}

	ngAfterContentChecked() {
		this.rows = [...this.rows];
	}

	public msgConfirmacao(data) {
		Swal.fire({
			title: "Confirmação",
			text: "Deseja mesmo excluir?",
			icon: "warning",
			showCancelButton: true,
			confirmButtonText: "Excluir",
			cancelButtonText: "Cancelar",
			customClass: {
				confirmButton: "btn btn-danger",
				cancelButton: "btn btn-primary ml-1",
			},
		}).then((result) => {
			if (result.isConfirmed) {
				this.clienteDelete(data);
			}
		});
	}

	public clienteDelete(id: number) {
		return this.clienteService.delete(id).subscribe(
			(res) => {
				if (res) {
					this.clienteContatoService.getIdCliente(id).subscribe(
						(res) => {
							for (let index = 0; index < res.length; index++) {
								this.clienteContatoService.delete(res[index].id).subscribe();
							}
						},
						(error) => error
					);
				}
				Swal.fire({
					title: "Sucesso!",
					text: "O item foi excluído.",
					icon: "success",
					confirmButtonText: "Confirmar",
				}).then((result) => {
					if (result.isConfirmed) {
						this.clienteService.get().subscribe(
							(res) => (this.rows = res),
							(error) => error
						);
					}
				});
			},
			(error) => {
				Swal.fire("Erro!", "Ocorreu um erro ao cadastrar.", "error");
			}
		);
	}

	nomeContratanteFilter(event) {
		const val = event.target.value.toLowerCase();

		// filter our data
		const temp = this.temp.filter(function (d) {
			if (d.nome_contratante != null) {
				return d.nome_contratante.toLowerCase().indexOf(val) !== -1 || !val;
			}
		});

		// update the rows
		this.rows = temp;
		// Whenever the filter changes, always go back to the first page
		this.table.offset = 0;
	}

	razaoSocialFilter(event) {
		const val = event.target.value.toLowerCase();

		// filter our data
		const temp = this.temp.filter(function (d) {
			if (d.razao_social != null) {
				return d.razao_social.toLowerCase().indexOf(val) !== -1 || !val;
			}
		});

		// update the rows
		this.rows = temp;
		// Whenever the filter changes, always go back to the first page
		this.table.offset = 0;
	}

	nomeFantasiaFilter(event) {
		const val = event.target.value.toLowerCase();

		// filter our data
		const temp = this.temp.filter(function (d) {
			return d.nome_fantasia.toLowerCase().indexOf(val) !== -1 || !val;
		});

		// update the rows
		this.rows = temp;
		// Whenever the filter changes, always go back to the first page
		this.table.offset = 0;
	}

	cnpjFilter(event) {
		const val = event.target.value.toLowerCase();

		// filter our data
		const temp = this.temp.filter(function (d) {
			return d.cpf_cnpj_lead.toLowerCase().indexOf(val) !== -1 || !val;
		});

		// update the rows
		this.rows = temp;
		// Whenever the filter changes, always go back to the first page
		this.table.offset = 0;
	}

	cidadeFilter(event) {
		const val = event.target.value.toLowerCase();

		// filter our data
		const temp = this.temp.filter(function (d) {
			return d.cidade.toLowerCase().indexOf(val) !== -1 || !val;
		});

		// update the rows
		this.rows = temp;
		// Whenever the filter changes, always go back to the first page
		this.table.offset = 0;
	}

	estadoFilter(event) {
		const val = event.target.value.toLowerCase();

		// filter our data
		const temp = this.temp.filter(function (d) {
			return d.estado.toLowerCase().indexOf(val) !== -1 || !val;
		});

		// update the rows
		this.rows = temp;
		// Whenever the filter changes, always go back to the first page
		this.table.offset = 0;
	}
}
